<template>
  <div class="ta-auction-viewing-info" v-if="viewingInfo">
    <slot name="icon">
      <b-icon-eye-fill class="mr-1" />
    </slot>
    <b v-if="label" class="ta-auction-viewing-info-label">{{ label }}: </b>
    <div class="ta-auction-viewing-info-value" v-html="viewingInfo"></div>
  </div>
</template>

<script>

import auctionViewMixin from "@/mixins/auctionViewMixin";

export default {
  name: "AuctionViewingInfo",
  mixins: [auctionViewMixin],
  props: {
    label: {
      type: [Boolean, String],
      default() {
        return this.$t('Viewing Information')
      }
    },
  }
}
</script>

<style lang="scss" scoped>
</style>
